/**
 * Owner: Masa Bayu
 * File: HighlightOverlay.tsx
 * Date:Time: 2026-10-05 15:27
 * Description: Fasa 27 · highlight paint layer · pointer-events none.
 */

import type { ReactElement } from 'react';
import type { HighlightBox } from '@qx/qx-interaction-engine';

export type HighlightOverlayProps = {
  readonly boxes: readonly HighlightBox[];
};

/**
 * Layer 6 · above body (5) · below header/footer (10).
 * pointer-events: none so hit-test receives clicks on the page sheet.
 */
export function HighlightOverlay({ boxes }: HighlightOverlayProps): ReactElement {
  return (
    <div
      className="qx-layer-highlight"
      data-qx-layer="highlight"
      data-fasa27-interaction=""
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 6,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {boxes.map((box, index) => (
        <div
          key={`${box.atomId}-${index}`}
          data-highlight-atom={box.atomId}
          style={{
            position: 'absolute',
            left: `${box.x}px`,
            top: `${box.y}px`,
            width: `${box.width}px`,
            height: `${box.height}px`,
            backgroundColor: 'rgba(255, 255, 0, 0.4)',
            borderRadius: '2px',
          }}
        />
      ))}
    </div>
  );
}

export default HighlightOverlay;
